import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9w42c3xo5a: FaireBrandEntity = {
  token: "b_9w42c3xo5a",
  type: "brand",
  name: "Happy Hippo Bath",
  avatarUrl:
    "https://cdn.faire.com/fastly/7583df3f51b8cc49fa9c6eefeed8ac53bdaad83a651c44a52b3f45a44d95f1bc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a8e433a1378ade8b96c40eb21c91c0f749a231d6cdfce4b1f5452c6adf811d24.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7583df3f51b8cc49fa9c6eefeed8ac53bdaad83a651c44a52b3f45a44d95f1bc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a8e433a1378ade8b96c40eb21c91c0f749a231d6cdfce4b1f5452c6adf811d24.png",
  location: "Red Deer, AB, CAN",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 238,
  isInsider: false,
  description:
    "We're a group of artisans crafting beautiful bath and skincare products - and have been since 2007!\n\nWe began in a home in Sylvan Lake, Alberta, making tub-friendly products that are safe for our kids and fun to use.\n\nWord spread about our fun, quality bath products and we slowly grew, adding on more artisans and selling at craft shows and seasonal holiday stores in malls across Canada.\n\nBy 2012 we became a regular white label/private manufacturer for some of the biggest names in bath and body care in Canada and expanded our operations to manufacture our own bath and skincare products.\n\nIn 2019 we decided to focus on only making Happy Hippo products and using our expertise to expand our products to offer more than just bath bombs, salts and scrubs.\n\nNow we only craft products that bring us happiness when we use them - and we hope they can bring you happiness too.\n\nWishing you all happiness in the world,\n\nAdam\n\nLead Product Designer",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:06.806Z",
    importedBy: "entity-db-cli",
  },
};
